import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=logged
  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    check();
  }, [check]);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <Ctx.Provider value={{ user, setUser, logout, check }}>{children}</Ctx.Provider>;
};

export const useAuth = () => useContext(Ctx);
